var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Route } from 'react-router';
import { isUserPermitted } from '../Permit/PermitRender';
import { useUserState } from '../User/UserContext';
export const RoleRoute = (_a) => {
    var { children, permissions = {} } = _a, rest = __rest(_a, ["children", "permissions"]);
    const userState = useUserState();
    const permitted = isUserPermitted(userState, permissions);
    if (!permitted.permitted) {
        return (React.createElement(React.Fragment, null,
            " ",
            permitted.why));
    }
    return React.createElement(Route, Object.assign({}, rest));
};
//# sourceMappingURL=RoleRoute.js.map